import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";

import { SetupAccountForm } from "../Forms/Auth";
import withUnAuth from "./withUnAuth";
import Cookies from "js-cookie";

const defaultCountryCode = window.location.href.includes("nordicrouting.se") ? "se" : "sg";

const SetupAccountPage = ({ user }) => {
  const [countryCodeInit, setCountryCodeInit] = useState(defaultCountryCode);

  useEffect(() => {
    setCountryCodeInit(Cookies.get(`CountryCode-${user._id}`) || defaultCountryCode);
  }, []);
  return (
    <div className="SignUpPage SetupAccountPage">
      <Row>
        <Col xs={0} sm={0} md={{ span: 12 }}>
          {!window.location.origin.includes("nordicrouting.se") && (
            <div
              className="LeftImg"
              style={{
                backgroundImage: "url('/login-logo.jpg')",
                backgroundSize: "cover",
              }}
            />
          )}
        </Col>
        <Col xs={24} sm={24} md={{ span: 12 }}>
          <SetupAccountForm user={user} countryCodeInit={countryCodeInit} />
        </Col>
      </Row>
    </div>
  );
};

export default withUnAuth(SetupAccountPage);
